export default "__VITE_ASSET__CjPbV5h1__"